<style scoped>
    .search-item {
        margin-top : 0px;
        margin-bottom : 0px;
    }
    .item-td {
        cursor:pointer;
    }
    .second-row {
        display: flex;
        font-size: 15px;
    }
    .sendTo {
        height: 20px;
        margin-right: 3%;
        text-align: center;
    }
    .from {
        width: 50px;
        background-color: lightgray;
    }
    .to {
        width: 30px;
        margin-left: 5%;
        color: white;
        background-color: gray;
    }
    .v-input--checkbox {
        margin-right: 30px;
    }
    .alert-row {
        display: flex;
        font-size: 13px;
        color: red;
    }
    .info-to{
        width: 50%;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }    
</style>
<template>
    <v-container fluid @click.left="menu = false">
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">署名待ち</v-col>
            </v-row>
        </v-container>
        <v-row justify="center">
            <v-col cols="12">
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                            <tbody>
                                <tr v-for="(item, index) in props.items" :key="index" @click="itemAction(item)">
                                    <td class="item-td" align="center">
                                        <progress-status-component :agreeCnt="item.agree_cnt" :allCnt="item.all_cnt" :contractError="item.contract_error_status"></progress-status-component>
                                    </td>
                                    <td class="item-td" align="left">
                                        {{ item.name }}
                                        <div class="second-row">
                                            <div class="sendTo to">To</div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span
                                                    class="info-to"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                        {{ getDestNames(item.agreements_or_folders_id) }}
                                                    </span>
                                                </template>
                                                <span>{{ getDestNames(item.agreements_or_folders_id) }}</span>
                                            </v-tooltip>                                            
                                        </div>
                                        <template v-if="item.contract_error_status">
                                            <div class="alert-row">
                                                メールアドレスをご確認いただき再度送信頂くか、お問合せよりご連絡ください。
                                            </div>
                                        </template>
                                    </td>
                                    <td class="item-td" align="center">
                                        <div>
                                            <div style="text-align: left;">{{ getLastSignedName(item) }}</div>
                                            <div style="text-align: left;">{{ getLastSignedDate(item) }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
    import moment from 'moment';
    const DAY_OF_WEEK = [ "日", "月", "火", "水", "木", "金", "土" ];
    export default {
        data() {
            return {
                // 項目一覧
                items: [],
                // 送信先名前
                destNames: [],
                // 項目一覧の数
                itemsLength: 0,
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                options: {},
                // テーブルヘッダー
                headers: [
                    { text: "ステータス", value: "no", align: "center", width: "10%", sortable: false},
                    { text: "件名", value: "contract_name", align: "center", width: "30%",},
                    { text: "最終確認", value: "", align: "center", width: "30%", sortable: false},
                ],

            };
        },
        props: {
            navi: [],
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get/verification').then(response => {
                    this.items = response.data.items;
                    this.itemsLength = response.data.items_cnt;
                    this.destNames = response.data.names;
                }
            );
        },
        methods: {
            // 送信先の名前取得
            getDestNames(id) {
                let vals = this.destNames[id];
                if (!vals) {
                    return;
                }
                return vals.length > 0 ? vals.join(",") : val[0];
            },
            // 署名済みの名前
            getLastSignedName(item) {
                return item.last_update_name + ' ' + item.last_update_email_address;
            },
            // 署名済み最終日付
            getLastSignedDate(item) {
                let status = "";
                if(item.last_update_signature_status == 1 || item.last_update_signature_status == 2){
                    if(item.last_update_is_destination == 0){
                        status =  "送信済み";
                    }else if (item.last_update_is_destination == 1){
                        if(item.last_update_is_authorizer == 0){
                            status =  "署名";
                        }else if(item.last_update_is_authorizer == 1){
                            status =  "承認";
                        }
                    }
                }else if(item.last_update_signature_status == 3){
                    status =  "転送";
                }
                let date = item.last_update_signature_date;
                let time = item.last_update_signature_time;
                if(item.last_update_signature_status == 2){
                     // 却下
                     date = item.rejection_date;
                     time = item.rejection_time;
                }
                
                let res = "";
                if (moment(new Date()).format("YYYY/MM/DD") == date) {
                    // 今日の場合は時刻を表示
                    res = time;
                } else {
                    if(date === null){
                        res = status;
                    }else{
                        // 別日の場合は年月日(曜日)を表示
                        let w = new Date(date).getDay();	// 曜日
                        res = date + "(" + DAY_OF_WEEK[w] + ") " + status;
                    }
                }
                return res;
            },
            // 契約書概要へのリンク
            itemAction(item, isInitPage = true) {
                if (item != null) {
                    // 契約クリック時
                    location.href = "/documents/document-management/summary/" + item.agreements_object_id;
                }
            },
        },
    };
</script>